import { HomeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 text-center px-4">
      <h1 className="text-6xl font-bold text-gray-800 dark:text-gray-200 mb-4">
        404
      </h1>
      <p className="text-2xl text-gray-600 dark:text-gray-400 mb-8">
        Oops! Page not found
      </p>
      <div className="max-w-md text-gray-500 dark:text-gray-400 mb-8">
        <p>
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>
      </div>
      <Button asChild>
        <Link to="/" className="inline-flex items-center">
          <HomeIcon className="mr-2 h-4 w-4" />
          <span>Go back home</span>
        </Link>
      </Button>
    </div>
  );
}
